<template lang="">
  <div class='mobile-foot'>
    <div class="btn" @click='downloadApp'>{{ $t("mobleTxt.download2") }} LesPark</div>
    <p v-if="isShowFootTxt">{{ $t('foot2.content1') }} {{ $t('foot2.content2') }} </p>
    <p v-if="isShowFootTxt">{{ $t('foot2.content6') }}</p>
    <p v-if="isShowFootTxt">{{ $t('foot2.content3') }}</p>
    <p v-if="!isShowFootTxt">ORIENT BASIC SCIENCE AND TECHNOLOGY PTE. LTD. </p>
    <ul class='foot-link'>
      <li class='link-iterm'><a  href="/help.html">{{ $t('foot.HelpCenter') }}</a> </li>
      <li class='link-iterm' v-if="isShowFootTxt"><a target='_blank' :href="goLinkUrl['rule_privacy'][goLinkeKey]+'?locale='+goLang+'&fromPage='+goLinkeKey">{{ $t('foot.PrivacyPolicy') }}</a> </li>
      <li class='link-iterm'><a target='_blank' :href="goLinkUrl['auto_extend_agreement'][goLinkeKey]+'?fromPage='+this.goLinkeKey">{{ $t('foot.ServiceAgreement') }}</a> </li>
      <li class='link-iterm'><a  href="/about-us.html">{{ $t('foot.CompanyProfile') }}</a> </li>
      <li class='link-iterm'><a  href="/about-us.html#joinmobile">{{ $t('foot.JoinUs') }}</a> </li>
      <li class='link-iterm'><a  href="/about-us.html#contactmobile">{{ $t('foot.contactUs') }}</a> </li>
      <li class='link-iterm' v-if="!isShowFootTxt"></li>
    </ul>
  </div>
</template>
<script>
import constans from "Constans";
import util from 'Common/util';
  export default {
    name: 'foot',
    data () {
      return {
        goLinkUrl:constans.UrlLink.goLink.foot,
        goLinkeKey:constans.UrlLink.getUrlKey(),
        goLang:'CN',
        isShowFootTxt:true,
      }
    },
    created() {
      let _arg = util.getLang();
      if (_arg.lang == 'tw') {
        this.goLang = 'TW'
      } else if (_arg.lang == 'cn') {
        this.goLang = 'CN'
      } else {
        this.goLang = 'US'
      }

      if(window.location.host.includes('lespark.us')){
        this.isShowFootTxt = false
      }else{
        this.isShowFootTxt = true
      }
    },
    methods: {
      // 下载app
      downloadApp() {
        const uL = navigator.language;
        if (uL == "zh-CN") {
          if (this.isShowFootTxt){
            window.location.href = "https://go.onelink.me/iAGK/lovepark"
          }else{
            window.location.href = "https://lespark.onelink.me/ewJF/xhb1upr6"
          }
        } else {
          if (this.isShowFootTxt){
            window.location.href = "https://go.onelink.me/KJsf/lovepark"
          }else{
            window.location.href = "https://lespark.onelink.me/ewJF/xhb1upr6"
          }
        }
      },
    },
  }
</script>
<style lang="" scoped>
  .mobile-foot {
    width: 100%;
    min-height: 52.4vw;
    background: #F7F7F7;
    box-sizing: border-box;
    padding-top: 2.6667vw;
  }

  .btn {
    width: 57.0667vw;
    height: 11.7333vw;
    line-height: 11.7333vw;
    text-align: center;
    background: linear-gradient(51deg, #FF7689 0%, #F855A6 100%);
    border-radius: 6.8vw;
    font-size: 4.2667vw;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #FFFFFF;
    margin: 0 auto 2.6667vw;
  }

  .mobile-foot>p {
    width: 100%;
    min-height: 3.7333vw;
    font-size: 2.6667vw;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    text-align: center;
    margin-bottom: 1.2vw;
  }


  .foot-link {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    margin-top: 2.6667vw;
  }

  .link-iterm {
    font-size: 3.2vw;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #555555;
    box-sizing: border-box;
    width: 33.3333vw;
    height: 4vw;
    margin-bottom: 4vw;
    text-align: center;
    /* flex: 1; */
  }
  .foot-link a{
    color: #555555;
  }
  .foot-link>li:nth-child(2) {
    border-right: 0.2667vw solid #D8D8D8;
    border-left: 0.2667vw solid #D8D8D8;
  }

  .foot-link>li:nth-child(5) {
    border-right: 0.2667vw solid #D8D8D8;
    border-left: 0.2667vw solid #D8D8D8;
  }
</style>



// WEBPACK FOOTER //
// src/views/components/mobilefoot.vue